var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _vm.keyValue < 1
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "房间", prop: "upIdList" } },
                    [
                      _c("el-cascader", {
                        staticClass: "form-item-width",
                        attrs: {
                          options: _vm.options,
                          props: _vm.propstree,
                          placeholder: "请选择房间"
                        },
                        on: { change: _vm.checkSelectHouse },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.keyValue > 0
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "房间" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.childData.areaName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "areaName", $$v)
                          },
                          expression: "childData.areaName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { id: "date", span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "装修时间", prop: "dates" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      format: "yyyy - MM- dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "费用起始日期",
                      "end-placeholder": "费用截止日期"
                    },
                    model: {
                      value: _vm.dates,
                      callback: function($$v) {
                        _vm.dates = $$v
                      },
                      expression: "dates"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.customerName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "customerName", $$v)
                      },
                      expression: "childData.customerName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间面积" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "260px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.houseArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "houseArea", $$v)
                      },
                      expression: "childData.houseArea"
                    }
                  }),
                  _vm._v(" m² ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.remark") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 2 }
                    },
                    model: {
                      value: _vm.childData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "remark", $$v)
                      },
                      expression: "childData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收费标准" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.handleAddCharge }
                    },
                    [_vm._v("添加")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", icon: "el-icon-delete" },
                      on: { click: _vm.handleDeletes }
                    },
                    [_vm._v("删除")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: {
                data: _vm.list,
                "element-loading-text": "数据正在加载中...",
                border: "",
                stripe: "",
                fit: "",
                "highlight-current-row": ""
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "收费项目" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.chargeItemName))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "收费标准名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.chargeStandardName))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "计费方式" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.chargeMathName))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "单价(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.price))])]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "指定金额(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.amount))])]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "备注" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.remark))])]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "上传附件" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: _vm.uploadUrl,
                        "file-list": _vm.files,
                        name: "files",
                        "on-error": _vm.handleError,
                        "before-upload": _vm.beforeUpload,
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess,
                        "show-file-list": true,
                        "on-preview": _vm.handlePreview
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c("br")
                    ],
                    1
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        "close-on-click-modal": false,
                        visible: _vm.dialogVisible,
                        title: "预览",
                        width: "600px"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible = $event
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.dialogImageUrl,
                          alt: ""
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handBindingCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }